import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-success-dialog',
  imports: [
    MatDialogContent,
    MatButton,
    MatDialogClose,
    TranslocoPipe,
  ],
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss']
})
export class SuccessDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {}

}

